/** @format */

import { createAction, props } from '@ngrx/store';

import { SelectedBundleSkus } from '@pdp/data-access/interfaces';

export const addProductToSet = createAction(
	'[Bundles] Add To Set',
	props<{ sku: SelectedBundleSkus }>()
);

export const removeProductFromSet = createAction(
	'[Bundles] Remove From Set',
	props<{ skuId: string }>()
);

export const addMultiProductToCart = createAction('[Bundles] Multi Add to Cart');
